export default {
    intNumeroConcurso: 6,
    Cliente_ID: 1,
    chrSerial: '999000000001',
    Session_ID: 'JBWEBETICKET_1',
    strToken: 'TESTEDEV',
    sdtDataHora: '2019-02-08T11:53:14.417Z',
    arrExtracaoData: [
      {
        sdtData: '2019-02-13 00:00',
        tnyExtracao: 35,
        sntConcurso: 6,
        intNumeroSorteio: 13022019
      },
      {
        sdtData: '2019-02-23 00:00',
        tnyExtracao: 35,
        sntConcurso: 6,
        intNumeroSorteio: 23022019
      }
    ],
    arrApostas: [
      {
        sntTipoJogo: 666,
        vchNumero: '02071425293038434459',
        vchPremio: '1.6',
        numValor: 1.11,
        numValorTotal: 1.11
      },
      {
        sntTipoJogo: 666,
        vchNumero: '19212839434446475158',
        vchPremio: '1.6',
        numValor: 1.11,
        numValorTotal: 1.11
      }
    ],
    Carrinho: [
      {
        Aposta_ID: 1,
        tipo: {
          Imagem_ID: 0,
          Mensagem_ID: 0,
          bitApenasPremioComPonto: 0,
          bitApenasPremiosFixos: 1,
          bitApenasSurpresinha: 0,
          bitApostaLinhaUnica: 0,
          bitApostaUnica: 0,
          bitBolao: 0,
          bitBrinde: 0,
          bitConcurso: 1,
          bitDefesaOnline: 0,
          bitEsconderNoMenu: 0,
          bitFatorExponencial: 0,
          bitInstantaneo: 0,
          bitME: 0,
          bitMultQtdPremios: 0,
          bitMultQtdSequencia: 0,
          bitMultQtdSequenciaUnidade2: 0,
          bitOnline: 0,
          bitOrdenacao: 1,
          bitOrdenacaoImpressao: 1,
          bitPermiteMultiploValorFixo: 0,
          bitPermiteOffline: 0,
          bitPermiteSequencia: 0,
          bitPermiteSequenciaUnidade2: 0,
          bitPermiteT: 1,
          bitPredatavel: 1,
          bitRepeticaoDescarga: 0,
          bitRifa: 0,
          bitSurpresinha: 1,
          bitTipoJogoUnico: 0,
          bitValidacaoExterna: 0,
          chrSeparador: 'x',
          intQtdMaxPule: 0,
          intQtdMaxSequencia: 0,
          numValorFixo: 0,
          numValorMinimoAposta: 1,
          sntFatorFixo: 1,
          sntIDTabelaInversao: 0,
          sntOrdemTerminal: 27,
          sntQtdItensLinha: 99,
          sntTipoJogo: 666,
          sntTipoJogoExibicao: 666,
          sntTipoJogoSistema: 666,
          strPremioSeco: ' ',
          tnyCombinacao: 0,
          tnyNumeroMax: 60,
          tnyNumeroMin: 1,
          tnyQtdFixaPremio: 0,
          tnyQtdItensApuracao: 0,
          tnyQtdMaximaPremio: 0,
          tnyQtdMinimaPremio: 0,
          tnyQtdRepPermitidas: 0,
          tnyTamanhoMax: 90,
          tnyTamanhoMin: 20,
          tnyTipoCalculoRepeticao: 1,
          tnyTipoCalculoSerie: 2,
          tnyTipoInversao: 0,
          tnyTipoRateioPadrao: 0,
          tnyUnidade: 2,
          tnyUnidadeImpressao: 2,
          vchCodigoTipoJogoIntegracao: '',
          vchNome: 'Super 6',
          vchPremioPadrao: '',
          vchSigla: 'S'
        },
        valor: 111,
        numeros: [
          '02',
          '07',
          '14',
          '25',
          '29',
          '30',
          '38',
          '43',
          '44',
          '59'
        ]
      },
      {
        Aposta_ID: 2,
        tipo: {
          Imagem_ID: 0,
          Mensagem_ID: 0,
          bitApenasPremioComPonto: 0,
          bitApenasPremiosFixos: 1,
          bitApenasSurpresinha: 0,
          bitApostaLinhaUnica: 0,
          bitApostaUnica: 0,
          bitBolao: 0,
          bitBrinde: 0,
          bitConcurso: 1,
          bitDefesaOnline: 0,
          bitEsconderNoMenu: 0,
          bitFatorExponencial: 0,
          bitInstantaneo: 0,
          bitME: 0,
          bitMultQtdPremios: 0,
          bitMultQtdSequencia: 0,
          bitMultQtdSequenciaUnidade2: 0,
          bitOnline: 0,
          bitOrdenacao: 1,
          bitOrdenacaoImpressao: 1,
          bitPermiteMultiploValorFixo: 0,
          bitPermiteOffline: 0,
          bitPermiteSequencia: 0,
          bitPermiteSequenciaUnidade2: 0,
          bitPermiteT: 1,
          bitPredatavel: 1,
          bitRepeticaoDescarga: 0,
          bitRifa: 0,
          bitSurpresinha: 1,
          bitTipoJogoUnico: 0,
          bitValidacaoExterna: 0,
          chrSeparador: 'x',
          intQtdMaxPule: 0,
          intQtdMaxSequencia: 0,
          numValorFixo: 0,
          numValorMinimoAposta: 1,
          sntFatorFixo: 1,
          sntIDTabelaInversao: 0,
          sntOrdemTerminal: 27,
          sntQtdItensLinha: 99,
          sntTipoJogo: 666,
          sntTipoJogoExibicao: 666,
          sntTipoJogoSistema: 666,
          strPremioSeco: ' ',
          tnyCombinacao: 0,
          tnyNumeroMax: 60,
          tnyNumeroMin: 1,
          tnyQtdFixaPremio: 0,
          tnyQtdItensApuracao: 0,
          tnyQtdMaximaPremio: 0,
          tnyQtdMinimaPremio: 0,
          tnyQtdRepPermitidas: 0,
          tnyTamanhoMax: 90,
          tnyTamanhoMin: 20,
          tnyTipoCalculoRepeticao: 1,
          tnyTipoCalculoSerie: 2,
          tnyTipoInversao: 0,
          tnyTipoRateioPadrao: 0,
          tnyUnidade: 2,
          tnyUnidadeImpressao: 2,
          vchCodigoTipoJogoIntegracao: '',
          vchNome: 'Super 6',
          vchPremioPadrao: '',
          vchSigla: 'S'
        },
        valor: 111,
        numeros: [
          '19',
          '21',
          '28',
          '39',
          '43',
          '44',
          '46',
          '47',
          '51',
          '58'
        ]
      }
    ],
    numValorApostas: 2.22,
    sntQuantidadeApostas: 2,
    valorTotal: 222,
    Sistema_ID: 1
  }


// WEBPACK FOOTER //
// ./src/mocking/salvar-apostas.js